const navigate = ({ baseRoute, path, queryParams, namespace }) => {
  return {
    type:    `Navigator => ${!!namespace ? `${namespace} =>` : ''} add path to history`,
    payload: {
      baseRoute,
      path,
      queryParams,
    },
    meta: {
      type: 'NAVIGATE',
    },
  };
};

const navigateReplace = ({ baseRoute, path, queryParams, namespace }) => {
  return {
    type:    `Navigator => ${namespace} => replace history with path`,
    payload: {
      baseRoute,
      path,
      queryParams,
    },
    meta: {
      type: 'NAVIGATE_REPLACE',
    },
  };
};

const navigateReload = ({ namespace }) => {
  return {
    type: `Navigator => ${namespace} => reload current page`,
    meta: { type: 'NAVIGATE_RELOAD' },
  };
};

export default {
  navigate,
  navigateReplace,
  navigateReload,
};
